import React from 'react';
import { Section } from './Section';
import { Check, X } from 'lucide-react';
export function TargetAudience() {
  const forWho = ['Hombres que terminan antes de los 5 minutos y sienten que decepcionan a su pareja.', 'Hombres que sufren de ansiedad de desempeño cada vez que conocen a alguien nuevo.', 'Hombres cansados de remedios caseros y soluciones químicas que no funcionan.', 'Hombres que quieren recuperar la confianza absoluta en su capacidad de satisfacer.'];
  const notForWho = ["Hombres que buscan una 'pastilla mágica' sin hacer el entrenamiento.", 'Hombres que no están dispuestos a dedicar 15 minutos diarios a su mejora personal.', 'Hombres que prefieren seguir excusándose en lugar de tomar acción técnica.'];
  return <Section data-id="element-163">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-164">
        {/* For Who */}
        <div className="bg-brand-gray/10 p-6 md:p-8 border border-brand-blue/30" data-id="element-165">
          <h3 className="font-display font-bold text-2xl md:text-3xl mb-6 uppercase text-brand-blue" data-id="element-166">
            Esto ES para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-167">
            {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-168">
                <Check className="w-6 h-6 text-brand-blue mr-3 flex-shrink-0 mt-1" data-id="element-169" />
                <span className="text-gray-300 text-lg" data-id="element-170">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For Who */}
        <div className="bg-brand-gray/10 p-6 md:p-8 border border-red-500/30" data-id="element-171">
          <h3 className="font-display font-bold text-2xl md:text-3xl mb-6 uppercase text-red-500" data-id="element-172">
            Esto NO ES para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-173">
            {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-174">
                <X className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-175" />
                <span className="text-gray-300 text-lg" data-id="element-176">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}